import { useState } from "react"
//import PopUpModalForm from "./PopUpModalForm"
import { Button } from "@/components/ui/button"
import PopUpModalForm from "./PopUpModalForm"


export default function EmailSubscribe() {
    const [openForm, setOpenForm] = useState(false)
    const openModalForm = () => {
        setOpenForm(true)
        return true
    }

    const closeForm = () => {
        setOpenForm(false)
    }

    return (
        <>
            <div className="bg-black w-full py-4 sm:py-6 lg:py-8 px-4 sm:px-6 lg:px-8">
                <div className="max-w-6xl mx-auto">
                    <div className="flex flex-col items-center justify-center lg:flex-row gap-4 md:gap-8 lg:items-center lg:justify-center  ">
                        {/* Text Content */}
                        <div className="flex-1 max-w-2xl">
                            <p className="text-sm sm:text-base lg:text-lg text-white text-center lg:text-left leading-relaxed whitespace-nowrap">
                                Stay updated with our latest offers, insights, and news.
                            </p>
                        </div>

                        {/* Button Container */}
                        <div className="w-full flex justify-center lg:w-auto max-w-sm lg:max-w-none">
                            <Button
                                className="px-16 min-w-[240px] uppercase mx-auto block btn"
                                variant={'red'}
                                onClick={openModalForm}
                            // className=" text-white rounded-lg px-4 py-2 sm:px-6 sm:py-3 w-full lg:w-auto min-w-[240px] text-xs sm:text-sm font-semibold uppercase tracking-wide shadow-lg hover:shadow-xl hover:scale-105 transition-all duration-200"
                            >
                                Unlock Insider Access
                            </Button>
                        </div>
                    </div>
                </div>
                {openForm && <PopUpModalForm openModalForm={openForm} closeForm={closeForm} />}
            </div>
        </>
    )
}